(() => {
  'use strict';
  const candidates = [
    {family:'vent-visors',handle:'ventvisor-15-26-f150-crew-17-26-s-duty-crew'},
    {family:'box-covers',handle:'lo-pro-box-cover-19-26-gm-1500-510'},
    {family:'hitches',handle:'class-3-hitch-15-26-f150'},
    {family:'remote-starts',handle:'2-way-lcd-remote-start-security-system-up-to-1-4-mile-range'},
    {family:'floor-liners',handle:'x-act-front-floor-liners-15-26-f150-extended-crew-cab'},
    {family:'running-boards',handle:'nxt-running-board-and-bracket-kit-19-26-gm-1500-20-26-hd-crew-cab-black-board-black-trim'},
    {family:'lighting',handle:'20in-led-light-bar'},
    {family:'tie-downs',handle:'bull-ring-tie-down'}
  ];
  function validImage(value) {
    try { const url=new URL(value,location.origin);return url.protocol==='https:'&&(url.hostname==='cdn.shopify.com'||url.hostname===location.hostname); } catch { return false; }
  }
  function qualify(product, candidate) {
    if(product.handle!==candidate.handle||!product.available||!Array.isArray(product.variants))return null;
    const variant=product.variants.find(item=>item.available&&Number.isFinite(item.price)&&item.price>0);
    const image=variant?.featured_image?.src||product.featured_image;
    if(!variant||!image||!validImage(image))return null;
    return {product,variant,image,family:candidate.family};
  }
  function choose(pool,limit,date=new Date()) {
    const day=Math.floor(Date.UTC(date.getUTCFullYear(),date.getUTCMonth(),date.getUTCDate())/86400000);
    const rotated=candidates.slice(day%candidates.length).concat(candidates.slice(0,day%candidates.length));
    const byHandle=new Map(pool.map(item=>[item.product.handle,item]));
    const families=new Set(),ids=new Set(),chosen=[];
    for(const candidate of rotated){
      const item=byHandle.get(candidate.handle);
      if(!item||families.has(item.family)||ids.has(item.product.id))continue;
      chosen.push(item);families.add(item.family);ids.add(item.product.id);
      if(chosen.length===limit)break;
    }
    return chosen;
  }
  function badges(product,variant) {
    const tags=new Set(Array.isArray(product.tags)?product.tags:[]),result=[];
    if(tags.has('to:best-seller:verified'))result.push('Best Seller');
    if(tags.has('to:hot-buy:verified')&&Number.isFinite(variant.compare_at_price)&&variant.compare_at_price>variant.price)result.push('Hot Buy');
    return result;
  }
  function card(item) {
    const {product,variant,image}=item;
    const node=(tag,className,text)=>{const element=document.createElement(tag);if(className)element.className=className;if(text!=null)element.textContent=text;return element;};
    const article=node('article','product-card'),link=node('a','product-card-link');
    link.href='/products/'+encodeURIComponent(product.handle)+'?variant='+encodeURIComponent(variant.id);
    const media=node('div','product-media'),img=node('img','product-card-image');
    img.src=image;img.alt=product.title;img.loading='lazy';img.width=700;img.height=700;media.append(img);
    const content=node('div','product-content');
    const badgeLabels=badges(product,variant);
    if(badgeLabels.length)content.append(node('span','featured-product-badges',badgeLabels.join(' · ')));
    content.append(node('small','',product.vendor),node('h3','',product.title));
    if(variant.sku)content.append(node('p','part-number','Part # '+(window.TruckOutfittersSku?.display(variant.sku)||variant.sku)));
    const stock=node('p','stock','Available to order');stock.dataset.available='true';content.append(stock);
    const bottom=node('div','product-bottom');
    const currency=window.Shopify?.currency?.active||'CAD';
    bottom.append(node('strong','',new Intl.NumberFormat('en-CA',{style:'currency',currency}).format(variant.price/100)),node('span','','View product →'));
    content.append(bottom);link.append(media,content);article.append(link);return article;
  }
  const initialize=(root=document)=>root.querySelectorAll('[data-featured-products]').forEach(section=>{
    if(section.dataset.initialized)return;section.dataset.initialized='true';
    const grid=section.querySelector('[data-featured-grid]'),heading=section.querySelector('[data-featured-heading]'),status=section.querySelector('[data-featured-status]'),retry=section.querySelector('[data-featured-retry]');
    heading.textContent='Featured';retry.textContent='Try loading featured products again';grid.replaceChildren();
    const load=async()=>{
      retry.hidden=true;status.textContent='Loading featured products…';section.setAttribute('aria-busy','true');
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
      try{
        const pool=[];
        for(let start=0;start<candidates.length;start+=4){
          const batch=await Promise.allSettled(candidates.slice(start,start+4).map(async candidate=>{
            const url=new URL('/products/'+candidate.handle+'.js',location.origin);
            const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
            const response=await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});
            if(!response.ok)return null;
            return qualify(await response.json(),candidate);
          }));
          for(const result of batch)if(result.status==='fulfilled'&&result.value)pool.push(result.value);
        }
        const limit=Math.min(12,Math.max(4,Number(section.dataset.limit)||4)),chosen=choose(pool,limit);
        if(!chosen.length)throw new Error('No eligible featured products');
        grid.replaceChildren(...chosen.map(card));status.textContent='';
      }catch{status.textContent='Featured products could not be loaded.';retry.hidden=false;}
      finally{clearTimeout(timer);section.removeAttribute('aria-busy');}
    };
    retry.addEventListener('click',load);load();
  });
  document.addEventListener('DOMContentLoaded',()=>initialize());
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
